module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/comprehendmedical-2018-10-30.paginators.json
// module id = 427
// module chunks = 30